import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Receipt } from "lucide-react";
import FacturationManager from "@/features/ventes/components/facturation/FacturationManager";

export const Route = createFileRoute("/_app/ventes/facturation/")({
  staticData: {
    title: "Facturation",
    icon: Receipt,
    tab_icon: Receipt,
    permission: PERMISSIONS.VENTES.FACTURES.VIEW,
    module: "ventes",
    order: 50,
    showInTab: true,
    showInNav: true,
    showInBreadcrumb: true,
    description: "Gestion de la facturation",
  },
  component: FacturationManager,
});
